export default __webpack_public_path__ + "static/media/GettyImages-56901647-581032823df78c2c7349a8a0.9e73af1c.webp";